import React, { useState, useEffect } from 'react';
import { getAllCategories } from '../../../../api/services/blogPostCategoriesApi';
import { getFeaturedBlogPosts } from '../../../../api/services/blogPostsApi';

import BlogCategoriesArea from '../BlogCategoriesArea/BlogCategoriesArea';
import BlogFeaturedArea from '../BlogFeaturedArea/BlogFeaturedArea';

import './BlogSideBar.css';

const BlogSideBar = () => {
  const [blogPostCategories, setBlogPostCategories] = useState([]);
  const [featuredBlogPosts, setFeaturedBlogPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSidebarData = async () => {
      setIsLoading(true);

      try {
        const categories = await getAllCategories();
        const categoriesOnSideBar = categories.filter(
          (c) => c.showOnBlogSideBar,
        );
        setBlogPostCategories(categoriesOnSideBar);

        const res = await getFeaturedBlogPosts({
          limit: 10,
        });

        setFeaturedBlogPosts(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSidebarData();
  }, []);

  return (
    <>
      {!isLoading && (
        <div className='blog-side-bar-container'>
          <div>
            {!!blogPostCategories.length && (
              <BlogCategoriesArea blogPostCategories={blogPostCategories} />
            )}
            {!!featuredBlogPosts.length && (
              <BlogFeaturedArea featuredBlogPosts={featuredBlogPosts} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BlogSideBar;
